import 'angular:locale/data:de';
import 'angular:locale/data:nl';
import 'angular:locale/data:en';
import './projects/app/src/polyfills.ts';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
